import axios from 'axios'

import { useAuthentication } from '../auth'

class ApiInstance {
  constructor(url) {
    const baseURL = new URL(url, window.location.origin).toString()
    this.instance = axios.create({
      baseURL: baseURL.replace(/^\/+|\/+$/g, ''),
      withCredentials: true
    })
    this.instance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error?.response?.status == 401 && !window.location.pathname.startsWith('/demo/')) {
          const auth = useAuthentication()
          auth.logout()
        }
        return Promise.reject(error)
      }
    )
  }

  extend(url) {
    return new ApiInstance(
      `${this.instance.defaults.baseURL}/${url.replace(/^\/+|\/+$/g, '')}`
    )
  }

  get(url, config) {
    return this.instance.get(url, config)
  }

  post(url, data, config) {
    return this.instance.post(url, data, config)
  }

  patch(url, data, config) {
    return this.instance.patch(url, data, config)
  }

  put(url, data, config) {
    return this.instance.put(url, data, config)
  }

  delete(url, data, config) {
    return this.instance.delete(url, data, config)
  }

  head(url, config) {
    return this.instance.head(url, config)
  }
}


export const authApi = new ApiInstance('/api/auth')
export const resourceApi = new ApiInstance('/api/resource')
export const institutionApi = new ApiInstance('/api/institution')
export const azureApi = new ApiInstance('/.auth')
